import { TickerPriceSummary } from '#/components/detail/TickerPriceSummary';
import { Ticker } from '#/components/ui/Ticker';

// Structural so each product overview (equity/ETF/mutual fund) fits directly.
interface CondensedTickerSummaryOverview {
  symbol: string;
  name?: string | null;
  current_price?: number | null;
}

interface CondensedTickerSummaryProps {
  overview: CondensedTickerSummaryOverview | null | undefined;
  /** Product-specific change fields (equity/ETF 5Y, mutual fund 1Y). */
  percentChange?: number | null;
  valueChange?: number | null;
  /** Period label appended to the value change, e.g. '5Y'. */
  changePeriodLabel: string;
}

/**
 * Ticker summary row that docks into the sticky section nav on mobile once the
 * in-place summary scrolls away. Owns its docked-bar chrome and renders nothing
 * when there's no price data, so callers only gate on whether to dock it.
 */
export function CondensedTickerSummary({
  overview,
  percentChange,
  valueChange,
  changePeriodLabel,
}: CondensedTickerSummaryProps) {
  const hasPriceData =
    overview != null &&
    (overview.current_price != null ||
      percentChange != null ||
      valueChange != null);

  if (!hasPriceData) {
    return null;
  }

  return (
    <div className="px-gap pt-16 lg:hidden">
      <div className="flex items-center justify-between gap-8 overflow-hidden">
        <div className="flex items-center gap-8 overflow-hidden">
          <Ticker symbol={overview.symbol} size="sm" />
          {overview.name && (
            <p className="text-fg-subheader text-static-12 hidden truncate sm:block">
              {overview.name}
            </p>
          )}
        </div>
        <TickerPriceSummary
          condensed
          price={overview.current_price}
          percentChange={percentChange}
          valueChange={valueChange}
          valueChangeSuffix={` ${changePeriodLabel}`}
        />
      </div>
    </div>
  );
}
